var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-one-fifth"},[_c('ImagePreview',{attrs:{"image":_vm.image,"project":_vm.project},on:{"show-details":_vm.openDrawer}}),_c('ImageDetailsDrawer',{attrs:{"active":_vm.showDrawer,"image":_vm.image,"editable":true,"context":_vm.context},on:{"close":function($event){_vm.showDrawer = false},"delete":_vm.handleDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }